export const AWARDS: string[] = [
  "2026 — TikTok Live Platform Best AI Coding Award",
  "2024 — Exceeding Expectations Award for the Widgets project",
  "2020 — YPT Stop Human Trafficking Hackathon Champion",
];

export const SHARINGS: string[] = [
  "2026 — Compound Engineering for agents",
  "2026 — Ralph Loops with Subagents",
  "2025 — Introduction to Data Platform Infrastructure",
  "2024 — Data Visualization Practices in User Experience",
  "2023 — Module Federation",
  "2022 — Panelist speaking for General Assembly's event: “The Roadmap to Landing Your Next Job as a Software Engineer\"",
  "2022 — Frontend Map Visualisations and Map Tiles Server",
  "2021 — Software Testing Strategies",
];
